import React from 'react';

const Footer = () => {
  return (
    <div className='mt-24 py-10 bg-black bg-opacity-20'>
      <p className='text-center text-xs md:text-md text-gray-400'>Designed by <span className='text-cyan-500'>Toukir Ahammed</span></p>
      <p className='text-center text-xs md:text-md text-gray-400 mt-3 flex gap-5 justify-center'><a href=""><span>LinkedIn</span></a> <a href=""><span>GitHub</span></a> <a href=""><span>Facebook</span></a></p>
    </div>
  );
};

export default Footer;